import './App.css';
import LandingPage from './LandingPage/LandingPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import LoginPage from './Login/LoginPage';
import ForgotPasswordPage from './Login/ForgotPasswordPage';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PitchUploadPage from './Pitching/PitchUploadPage';
import ProducerPitchesPage from './Pitching/ProducerPitchesPage';
import RegistrationPage from './Registration/RegistrationPage';
import PublicTeamRegistrationPage from './Registration/PublicTeamRegistrationPage';
import ProfilePage from './Profiling/ProfilePage';
import ProfilesListPage from './Profiling/ProfilesListPage';
import LearningCertificationPage from './LearningCertification/LearningCertificationPage';
import FeedbackPage from './Feedback/FeedbackPage';
import EquipmentRentalsPage from './Sourcing/EquipmentRentalsPage';
import ProductionSourcingHubPage from './Sourcing/ProductionSourcingHubPage';
import MaheshPhotographyDronePage from './Sourcing/MaheshPhotographyDronePage';
import VccStudioPage from './Sourcing/VccStudioPage';
import FundingProjectsPage from './Funding/FundingProjectsPage';
import ChatPage from './Chat/ChatPage';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function App() {
  return (
    <>
    <ToastContainer position="top-right" autoClose={3000} />
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter>
        <Routes>
            <Route path='/' element={<LandingPage/>}/>
            <Route path='/register' element={<RegistrationPage/>}/>
            <Route path='/team-registration' element={<PublicTeamRegistrationPage/>}/>
            <Route path='/login' element={<LoginPage/>}/>
            <Route path='/forgot-password' element={<ForgotPasswordPage/>}/>
            <Route path='/home' element={<LandingPage/>}/>
            {/* <Route path='/register' element={<RegistrationPage/>}/> */}
            <Route path='/pitch-upload' element={<PitchUploadPage/>}/>
            <Route path='/producer-pitches' element={<ProducerPitchesPage/>}/>
            <Route path='/profile' element={<ProfilePage/>}/>
            <Route path='/profiles' element={<ProfilesListPage/>}/>
            <Route path='/learning-certification' element={<LearningCertificationPage/>}/>
            <Route path='/certified-professional' element={<LearningCertificationPage/>}/>
            <Route path='/feedback' element={<FeedbackPage/>}/>
            <Route path='/production-sourcing' element={<ProductionSourcingHubPage/>}/>
            <Route path='/equipment-rentals' element={<EquipmentRentalsPage/>}/>
            <Route path='/mahesh-photography-drone-services' element={<MaheshPhotographyDronePage/>}/>
            <Route path='/vcc-studio-hyd' element={<VccStudioPage/>}/>
            <Route path='/funding-projects' element={<FundingProjectsPage/>}/>
            <Route path='/chat' element={<ChatPage/>}/>
        </Routes>
      </BrowserRouter>
    </GoogleOAuthProvider>
    </>
  );
}

export default App;
